import api from '@/api'

export default {
  cancelNewMessage({ commit }) {
    commit('CANCEL_NEWMESSAGE')
  },
  setMessageActivation({ commit }, data) {
    commit('SET_MESSAGEACTIVATION', data)
  },
  addMessage({ commit, state }, data) {
    commit('ADD_MESSAGE', data)
  },
  setMessage({ commit, state }, data) {
    commit('SET_MESSAGE', data)
  },
  async getMessages({ commit, state }) {
    return new Promise((resolve, reject) => {
      api.lookup({ key: 'messages.precanned', showAll: true }, { headers: { 'content-type': 'application/json' } })
        .then(response => {
          commit('SET_MESSAGES', response.data)
          resolve(response)
        })
    })
  },
  async saveMessages({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.savePreCannedMessages(data, { headers: { 'content-type': 'application/json' } })
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/message/actions.js